import { map } from "lodash"
import { Component } from "react"
import { ExploreOutlined } from "@mui/icons-material"
import { Button, Paper, Select, MenuItem, InputLabel, FormControl, IconButton, ClickAwayListener, Popper } from "@mui/material"
import SearchList from "components/search-list"
import PropTypes from "prop-types"
import ForecastInformation from "./information"
import "./style.scss"

const EMPTY_STATE = {
  menuParent: null,
}

const SETTINGS = {
  horizon: {
    values: [{
      value: 1,
      label: "1 Day",
    }, {
      value: 5,
      label: "1 Week",
    }, {
      value: 21,
      label: "1 Month",
    }, {
      value: 63,
      label: "3 Months",
    }, {
      value: 126,
      label: "6 Months",
    }, {
      value: 252,
      label: "1 Year",
    }],
  },
}

class ForecastSelector extends Component {
  static propTypes = {
    setForecast: PropTypes.func.isRequired,
    setHorizon: PropTypes.func.isRequired,
    forecasts: PropTypes.array.isRequired,
    horizon: PropTypes.number.isRequired,
    selectedForecast: PropTypes.object,
    isOpPro: PropTypes.bool.isRequired,
  }

  constructor(...args) {
    super(...args)
    this.state = EMPTY_STATE
  }

  openMenu = event => {
    const menuParent = event.currentTarget

    this.setState(state => {
      if (state.menuParent) {
        return EMPTY_STATE
      } else {
        return { menuParent }
      }
    })
  }

  closeMenu = event => {
    // ignore events on the button
    if (event.target.id !== "search-forecasts" && event.target.id !== "search-forecasts-compass") {
      this.setState(EMPTY_STATE)
    }
  }

  setForecast = selected => {
    const { setForecast } = this.props
    setForecast(selected.id)
    this.setState(EMPTY_STATE)
  }

  setHorizon = event => {
    const { value } = event.target
    const { setHorizon } = this.props
    setHorizon(value)
  }

  resetForecast = () => {
    const { setForecast } = this.props
    setForecast(null)
    this.setState(EMPTY_STATE)
  }

  render() {
    const { forecasts, selectedForecast, horizon, isOpPro } = this.props
    const { menuParent } = this.state

    const elements = map(forecasts, forecast => {
      return {
        id: forecast.id,
        name: forecast.name,
        header: forecast.name,
      }
    })

    return <div className="components_forecast-selector">
      <Paper square className="element-wrapper">
        <FormControl variant="standard" className="forecasts">
          <ForecastInformation {...{ selectedForecast, isOpPro }} />
          <div className="forecast-buttons-wrapper">
            {selectedForecast && <Button variant="outlined" color="primary" className="reset-forecast-button" onClick={this.resetForecast}>Remove Forecast</Button>}
            <IconButton
              onClick={this.openMenu}
              className="search-forecasts-button"
              id="search-forecasts"
              size="large"
            >
              <ExploreOutlined id="search-forecasts-compass" />
            </IconButton>
          </div>
          <ClickAwayListener onClickAway={this.closeMenu}>
            <Popper
              className="forecasts-menu"
              disablePortal
              anchorEl={menuParent}
              open={!!menuParent}
              placement="bottom-end"
            >
              <SearchList
                elements={elements}
                title="Saved Forecasts"
                selectElement={this.setForecast}
                noElementDisplay={{
                  primary: "No saved forecast found.",
                }}
              />
            </Popper>
          </ClickAwayListener>
        </FormControl>
      </Paper>
      <Paper square className="element-wrapper">
        <FormControl variant="standard" className="horizon">
          <InputLabel htmlFor="horizon">Horizon</InputLabel>
          <Select
            variant="standard"
            className="horizon-select-input"
            value={horizon}
            onChange={this.setHorizon}
            inputProps={{ name: "horizon", id: "horizon" }}
          >
            <MenuItem disabled>Select Horizon</MenuItem>
            {SETTINGS.horizon.values.map((item, i) =>
              <MenuItem key={i} value={item.value}>{item.label}</MenuItem>,
            )}
          </Select>
        </FormControl>
      </Paper>
    </div>
  }
}

export default ForecastSelector
